<template>
  <div>
    <vx-card>
      <div class="vx-row">
        <div class="vx-col w-full md:w-2/3" >
          <h4>Tus cuentas de banco.</h4>
          <p class="mb-2 mt-2">
            Agrega, consulta o administra las cuentas de banco con las que deseas participar en la Red.
            Puedes tener tantas cuentas sean necesarias, pero considera que necesitas tener al menos una
            cuenta verificada para poder operar dentro de RedGirasol con la que podrás retirar los fondos
            de tu saldo disponible en el momento en que lo necesites.
            <span class="bold">El proceso de verificación de cuentas podría tomar hasta 72 horas.</span>
          </p>
          <p class="mb-2 mt-2">
            En caso de tener más de una cuenta, selecciona una CLABE predeterminada al dar clic en el icono
            de estrella dentro de las acciones. Esta será tu cuenta principal y estará resaltada en color negro.
            Las cuentas que se encuentren en verificación no podrán ser utilizadas hasta concluir con el proceso.
          </p>
        </div>
      </div>

      <!-- tabla de cuentas de banco -->
      <div class="vx-row mt-6 mb-2">
        <div class="vx-col xxl:w-2/3 lg:w-full w-full">
          <div class="data-list-container data-list-list-view data-list-rows vs-con-loading__container" id="main-div">
            <vs-table class="mt-1" ref="accountsTable" :data="formattedAccounts" stripe noDataText="No hay cuentas registradas">
              <template slot="thead">
                <vs-th class="bold">Banco</vs-th>
                <vs-th class="bold">CLABE / SWIFT / BIC</vs-th>
                <vs-th class="bold">Estatus</vs-th>
                <vs-th class="bold">Pred.</vs-th>
              </template>

              <template slot-scope="{data}">
                <tbody>
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" :state="isAccountSelected(tr) ? 'black' : null" >
                  <vs-td>
                    {{ tr.bank_name }}
                  </vs-td>
                  <vs-td>
                    {{ tr.clabe }}
                  </vs-td>
                  <vs-td>
                    {{ tr.status_name }}
                  </vs-td>
                  <!--vs-td>
                    <span v-if="!isAccountSelected(tr) && isSelectable(tr) && isVerified(tr)" class="text-sm text-primary">
                      Seleccionar
                    </span>
                  </vs-td-->
                  <vs-td>
                    <div class="flex items-center flex-grow flex-no-wrap w-full">
                      <feather-icon icon="StarIcon" :svgClasses="getSelectIconClass(tr)" />
                    </div>
                  </vs-td>
                </vs-tr>
                </tbody>
              </template>
            </vs-table>
          </div>
        </div>
      </div>
      <!-- fin tabla de cuentas de banco -->
    </vx-card>

  </div>
</template>

<script>
import {BankAccountStatus} from "@/models/BankAccountStatus";

export default {
  name: "InvestorBankAccounts",
  components: {
  },
  props: {
    isMoral: { type: Boolean, required: true },
    userId: { type: [String,Number], required: true },
    personType: { type: [String,Number], required: true },
    hasBackofficeAccess: { type: Boolean, required: true },
    userData: { type: Object, required: true },
  },
  data(){
    return {
      userAccounts: [],
      formattedAccounts: [],
      accountIdSelected: null,
      accountIdToDelete: null,
      createdAccountId: null,
      preselectedAccountId: null,
      klassBase: "h-5 w-5 stroke-current",
      klassFull: "h-5 w-5 stroke-current hover:text-primary cursor-pointer",

      collections: {
        cities: [],
        states: [],
        countries: [],
        foreign_countries: [],
        banks: [],
        business_activities: [],
      },

      mexicoCountryId: 700,
      section_id_pm: 107,
      section_id_pfae: 103,

      currentTitle: "",
      currentView: null,
      currentUserAccount: null,
      currentFormattedAccount: null,

      onError: false,
      errorMssg: null,

      sectionInfo: null,
      docInfo: null,
      formEditionDisabled: false,

      currentIdForSelection: null,
      currentIdToDelete: null,

    }
  },
  async beforeMount(){
    this.showLoading(true)
    await this.getCollections();
    await this.getUserAccounts();
    await this.getSectionFields();
    this.setDefaults();
    this.showLoading(false)
  },
  computed: {
    onNewView(){
      return this.currentView === 0;
    },
    onEditView(){
      return this.currentView === 1;
    },
  },
  methods: {
    async refreshAccounts(){
      await this.getUserAccounts();
    },
    async onFinish(){
      this.isPopupActive = false;
      //await this.getUserAccounts();
    },
    getSelectIconClass(tr){
      let klass = this.klassBase;
      if(this.isAccountSelected(tr)){
        klass += " fill-current";
      }
      else {
        if(this.isSelectable(tr)){
          klass += " hover:text-primary cursor-pointer";
        }
        else {
          klass += " opacity-30";
        }
      }
      return klass;
    },
    getEditIconClass(tr){
      if(this.isAccountSelected(tr) || tr.is_verified){
        let klass = this.klassBase;
        klass += " opacity-25";
        return klass;
      }
      else {
        return this.klassFull;
      }
    },
    async getUserAccounts(){
      try {
        const res = await axios.get(`api/backoffice/bank-account/${this.userId}`);
        const accs = res.data;
        this.userAccounts = accs;
        this.formattedAccounts = [];
        accs.forEach(f => {
          let nacc = this.getFormattedAccount(f);
          this.formattedAccounts.push(nacc);
        });

        this.formattedAccounts.sort(function(a, b) {
          if(a.is_default){
            return -1
          }
          else if(b.is_default){
            return 1;
          }
          else if(a.is_verified && b.is_verified){
            return a.clabe > b.clabe;
          }
          else if(a.is_verified && !b.is_verified){
            return -1
          }
          else if(!a.is_verified && b.is_verified){
            return 1
          }
          return 0;
        });
      }
      catch (e) {
      }
    },
    getFormattedAccount(f){
      let nacc = {
        id: f.id,
        bank_id: f.bank_id,
        is_default: f.is_default === 1,
        is_verified: f.verified === BankAccountStatus.VERIFIED,
        status_name: BankAccountStatus.getAccountStatusName(f.verified),
      }

      if(f.bank && f.bank.country_id === this.mexicoCountryId){
        nacc.bank_name = f.bank.short_name;
        nacc.clabe = f.clabe;
      }
      else {
        nacc.bank_name = f.bank.name;
        nacc.clabe = f.bic_swift;
      }
      return nacc;
    },
    setDefaults(){
      let account = this.formattedAccounts.find(f => f.is_default);
      if(account != null) {
        this.accountIdSelected = account.id;
      }
    },
    async getSectionFields(){
      try {
        let sid = this.isMoral ? this.section_id_pm : this.section_id_pfae;
        let response = await axios.get(`/api/v1/forms/getSectionFields/${sid}`);
        this.sectionInfo = response.data.section;

        let response2 = await axios.get(`/storagev3/documents/section/${sid}`);
        this.docInfo = response2.data[0];
      }
      catch (e) {
      }
    },
    async getCollections(){
      try {
        let collectionsObjects = ['countriesList','foreignCountriesList','banksForMexico'];
        let params = "with[]=" + collectionsObjects.join("&with[]=");
        let res = await axios.get(`/api/v1/forms/getFormCollections?${params}`);
        let colls = res.data;
        this.collections.countries = colls.countriesList;
        this.collections.foreign_countries = colls.countriesList;
        this.collections.banks = colls.banksForMexico;
      }
      catch (e) {
        this.warn(e);
        this.failed = true;
      }
    },
    isAccountSelected(tr){
      return tr.id === this.accountIdSelected;
    },
    isSelectable(tr){
      return tr.is_verified;
    },
    isVerified(tr){
      return tr.is_verified;
    },
    clean(){
      this.onError = false
      this.errorMssg = null
    },
  }
}
</script>

<style scoped>

</style>